module.exports = __webpack_public_path__ + "static/img/1.b302aa8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/1.png
// module id = q5EM
// module chunks = 0